module.exports = __webpack_public_path__ + "static/media/logo-dark.7ea2fcd1.svg";